'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleMinus, iconCircleMinusTag } from '@ni/nimble-components/dist/esm/icons/circle-minus';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleMinus };
export { iconCircleMinusTag };
export const NimbleIconCircleMinus = wrap(IconCircleMinus);